import styled, { css } from 'styled-components';
import { margin, MarginProps } from 'styled-system';

import { InputMessageType } from '@chargify/custom-ui-components';

export const MessageContainer = styled.div<
  { type: InputMessageType } & MarginProps
>`
  ${({ theme, type }) => css`
    min-height: ${theme.lineHeights[
      theme.components.InputMessage.componentVariants.type.variants[type]
        .lineHeight
    ]};
  `};
  ${margin};
`;
